var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"fillPriceDifference cus-modal"},[_c('OmsForm',{attrs:{"form-config":_vm.formConfig}}),_vm._v(" "),_c('OmsButton',{staticClass:"modal-footer",attrs:{"btn-config":_vm.btnConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }